import { ApiGatewayApi } from "api";
import { addNotification, loading } from "layouts/AppLayout/modules";
import { put, takeEvery } from "redux-saga/effects";
import * as Actions from "../actions/AuthCompleteEmailVerification";
import { CredentialsProvider } from "./CredentialsProvider";

export function* completeEmailVerification(action: Actions.AuthCompleteEmailVerificationAction) {
    const { credentials } = action.payload;
    let caughtError: Error;
    try {
        const api =  new ApiGatewayApi(new CredentialsProvider(credentials));
        yield put(loading(true, action));
        yield api.completeVerification();
    } catch (e) {
        caughtError = e;
        yield put(addNotification(e.message, true));
    } finally {
        yield put(loading(false, action));
        yield put(Actions.completeEmailVerificationEnd(caughtError));
    }
}

export function* watchCompleteVerification() {
    yield takeEvery(Actions.AUTH_COMPLETE_EMAIL_VERIFICATION, completeEmailVerification);
}